import { accessDenied } from './accessDenied';
import { accountSelector } from './accountSelector';
import { authenticatorFooter } from './authenticatorFooter';
import { conclusion } from './conclusion';
import { corporateData } from './corporateData';
import { fixedFooter } from './fixedFooter';
import { integratorData } from './integratorData';
import { intro } from './intro';
import { lateralMenu } from './lateralMenu';
import { modals } from './modals';
import { paymentOptions } from './paymentOptions';
import { requestContact } from './requestContact';
import { resumeAndAuthorization } from './resumeAndAuthorization';
import { serviceError } from './serviceError';
import { termsAndConditions } from './termsAndConditions';

export const placeholders = {
	accessDenied,
	accountSelector,
	authenticatorFooter,
	conclusion,
	corporateData,
	fixedFooter,
	integratorData,
	intro,
	lateralMenu,
	modals,
	paymentOptions,
	requestContact,
	resumeAndAuthorization,
	serviceError,
	termsAndConditions,
};
